import axios from 'axios'

import { IUrlUtils } from 'v2/modules/lib/utils/url'

import { makeAccountService } from './accountService'
import { makeAuthService } from './authService'
import { makeBccAccountService } from './bccAccountService'
import { makeDomainService } from './domainService'
import { makeUserService } from './userService'
import { makeQn2cService } from './qn2cService'

const httpClient = axios.create()

export interface IEgdApiClientArgs {
  host: string
  commonHeaders: Record<string, any>
  urlUtils: IUrlUtils
}

export const EgdApiClient = ({ host, commonHeaders, urlUtils }: IEgdApiClientArgs) => {
  httpClient.defaults.headers.common = commonHeaders
  httpClient.defaults.baseURL = host

  const accountService = makeAccountService({ httpClient, urlUtils })
  const bccAccountService = makeBccAccountService({ httpClient, urlUtils })
  const domainService = makeDomainService({ httpClient, urlUtils })
  const userService = makeUserService({ httpClient, urlUtils })
  const authService = makeAuthService({ httpClient, urlUtils })
  const qn2cService = makeQn2cService({ httpClient, urlUtils })

  return Object.freeze({
    accountService,
    bccAccountService,
    domainService,
    userService,
    authService,
    qn2cService
  })
}

export type IEgdApiClient = ReturnType<typeof EgdApiClient>
